export const encryptEuroConfPayload = `
mutation encryptEuroConfPayload($payload:ToEncryptBody!){
    encryptEuroConfPayload(payload:$payload){
        encrypted
        url
    }
}`;